import { Progress } from "vant";
import {
  VueSpinner,
  // ...
} from "vue3-spinners";
import { CONSTANTS } from "@/helpers/constants";
export default {
  name: "Loading",
  components: {
    [Progress.name]: Progress,
    VueSpinner,
  },
  setup() {},
  data() {
    return {
      percent: 10,
      ifUp: true,
    };
  },
  async created() {},
  computed: {},
  mounted() {
    const timer = setInterval(() => {
      if (this.percent <= 100) this.percent = this.percent + 1;
    }, 10);
  },
  watch: {
    percent: function (newData) {
      // es5 syntax
      if (newData >= 100) {
        this.$store.dispatch("loadingStore/setLoadingFinished", true); // Gán biến
        this.$router.push("/home");
      }
    },
  },
  methods: {
    color_primary() {
      return CONSTANTS.color_primary;
    },
  },
};
